<template>
  <v-card>
    <v-form @submit.prevent="submit()" ref="editForm">
      <v-container>
        <v-layout row wrap>
          <dialog-header :title="'Edit'" :details="`Tipping Docket Header (${tippingDocket.id})`" :time="editedTippingDocket.updatedAt"></dialog-header>
          <flex-sub-header>Details</flex-sub-header>
          <v-flex xs12 sm6>
            <v-text-field
              label="External Reference"
              color="primary"
              v-model="editedTippingDocket.externalRef"
              :rules="externalRefRules"
              prepend-icon="note"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <date-picker-wrapper
              v-model="editedTippingDocket.date"
              :rules="dateRules"
              label="* Date"
              color="primary"
            ></date-picker-wrapper>
          </v-flex>
          <v-flex xs12 sm6>
            <v-switch label="Day" color="amber darken-1" v-model="editedTippingDocket.isDay"></v-switch>
          </v-flex>
          <v-flex xs12 sm6>
            <v-autocomplete
              :items="tips"
              label="* Tip"
              item-text="name"
              item-value="id"
              color="primary"
              v-model="editedTippingDocket.tipId"
              :rules="tipRules"
              :prepend-icon="$store.state.global.pages.tip.icon"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12 sm6>
            <v-autocomplete
              :items="projects"
              label="* Project"
              item-text="name"
              item-value="id"
              color="primary"
              v-model="editedTippingDocket.projectId"
              :rules="projectRules"
              :prepend-icon="$store.state.global.pages.project.icon"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6>
            <v-autocomplete
              :items="vehicles"
              label="* Vehicle"
              item-text="vehicleName_vehicleType"
              item-value="id"
              color="primary"
              v-model="editedTippingDocket.vehicleId"
              :rules="vehicleRules"
              :prepend-icon="$store.state.global.pages.vehicle.icon"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>

        <div v-if="different">
          <v-btn :color="primaryGrey" flat @click="discard()">Discard?</v-btn>
          <v-btn :color="primaryGreen" flat type="submit" :loading="loading">Save</v-btn>
        </div>
        <div v-else>
          <v-btn :color="primaryGrey" flat @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from "@/store/computed/storeHelpers";

import TippingService from "@/services/requests/tippingService";

// MIXINS
import TippingValidation from "../mixins/validation";
import getTips from "@/services/mixins/getMasterFiles/getTips";
import getProjects from "@/services/mixins/getMasterFiles/getProjects";
import getVehicles from "@/services/mixins/getMasterFiles/getVehicles";
import FormatDates from "@/services/mixins/formatDates";
import StatusItems from "../mixins/statusItems";

// COMPONENTS
import DialogHeader from "@/components/ui/dialogHeader";
import DatePickerWrapper from "@/components/ui/datePickerWrapper";

export default {
  mixins: [
    TippingValidation,
    getTips,
    getProjects,
    getVehicles,
    FormatDates,
    StatusItems
  ],
  components: {
    DialogHeader,
    DatePickerWrapper
  },
  data() {
    return {
      editedTippingDocket: this.clone(this.tippingDocket),
      loading: false,
      prefix: "editedTippingDocket"
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    discard() {
      this.editedTippingDocket = this.clone(this.tippingDocket);
      this.close();
    },
    submit() {
      if (!this.$refs.editForm.validate()) {
        this.snack({ text: "Please correct form errors", color: "red" });
        return;
      }
      this.save();
    },
    save() {
      this.loading = true;
      TippingService.updateTippingDocketHeader(this.editedTippingDocket)
        .then(result => {
          this.loading = false;
          this.$store.commit("tipping/setState", {
            prop: "fetchTippingDockets",
            value: true
          });
          //this.editedTippingDocket = this.clone(result.data.result.tippingDocket);
          this.snack({
            text: "Tipping Docket header was edited!",
            color: "green"
          });
          this.close();
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.snackError();
        });
    },
    clone(obj) {
      var editedTippingDocket = Object.assign({}, obj);
      editedTippingDocket.date = this.makeComputerDate(
        editedTippingDocket.date
      );
      return editedTippingDocket;
    }
  },
  computed: {
    different() {
      if (!this._.isEqual(this.tippingDocket, this.editedTippingDocket)) {
        return true;
      } else {
        return false;
      }
    }
  },
  props: {
    tippingDocket: Object
  },
};
</script>

<style>
</style>